
import React from "react";
import styled from "styled-components";

import { IViewProps, View } from "core/decorators/View";
import { BlockStylesConfig, toBlockCss } from "../common/BlockStylesConfig";
import { toTypographyCss, TypographyStylesConfig } from "../common/TypographyStylesConfig";
import BoxViewConfig from "./BoxConfig";

interface IBoxSectionProps {
	block: BlockStylesConfig;
	typography: TypographyStylesConfig;
}

const StyledBoxSection = styled.div<IBoxSectionProps>(
	({block, typography}: IBoxSectionProps) => [toBlockCss(block), toTypographyCss(typography)]
);

export enum BoxVariant {
	MINIMAL = "minimal",
	PANEL = "panel"
}

interface IBoxViewProps extends IViewProps<BoxViewConfig, BoxVariant> {
	title?: string | JSX.Element;
}

/**
 * @description view with header and body sections, not interactive
 */
@View({ id: "box", configClass: BoxViewConfig, variants: BoxVariant })
export class BoxView extends React.PureComponent<IBoxViewProps, any> {

	public render() {
		const { config, title } = this.props;

		return (
			<div>
				{
					!config.hideTitle && (
						<StyledBoxSection
							block={config.headerDefaultState}
							key="head"
							typography={config.headerTypography}
							style={!config.hideTitle ? {borderBottomRightRadius: 0, borderBottomLeftRadius: 0} : undefined}
						>
							{title}
						</StyledBoxSection>
					)
				}
				<StyledBoxSection
					block={config.bodyDefaultState}
					key="body"
					typography={config.bodyTypography}
					style={!config.hideTitle ? {borderTopRightRadius: 0, borderTopLeftRadius: 0, borderTopWidth: 0} : undefined}
				>
					{this.props.children}
				</StyledBoxSection>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/views/box/Box.view.tsx